import { Stack } from '@mui/system';
import { Outlet } from 'react-router-dom';

export default function () {
  return (
    <Stack height='100%' component='div'>
      <Outlet />
    </Stack>
  );
}
